/**
 * Condiciones comerciales para distribuidores.
 *
 * La sección se arma hoy con la pieza de diseño completa (ver
 * `DistributorTerms`), así que acá solo queda el contenido del modal
 * "Ver condiciones comerciales", que sí es HTML.
 *
 * PENDIENTE: el documento pide mostrar la sección únicamente a distribuidores,
 * pero el login no informa el rol; `profile_data` trae user, nice_name,
 * visible_columns, forbidden_categories, custom_condition y company. Para
 * filtrar por rol hay que agregarlo en `generate_profile_data()` del plugin
 * api-bearer-auth y después ajustar `DistributorTerms`.
 */
export const COMMERCIAL_TERMS_DETAIL = [
	"25% en factura por condición de distribuidor.",
	"+5% financiero cuando la cuenta no registra facturas vencidas. Tolerancia: 48 horas. Puede suspenderse ante reiteración de atrasos.",
	"+5% en factura por volumen para clientes con compras de 500 HK o más en los últimos 90 días.",
	"Los descuentos se aplican según la condición comercial de cada cuenta."
];

export default COMMERCIAL_TERMS_DETAIL;
